export default __webpack_public_path__ + "media/images/logo-4bcf86820d55b55c313a1a1a8a794c49.svg";